import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSettings } from '../context/SettingsContext';
import { Spin } from 'antd';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const { settings, loading, error } = useSettings();
  const location = useLocation();

  if (location.pathname === '/admission') {
    return <Navigate to="/admission" replace />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (error && location.pathname !== '/maintenance') {
      return <Navigate to="/maintenance" replace />;
  }

  // Only block the whole app on the INITIAL load (no settings yet). Later
  // re-fetches (e.g. after saving settings) must not remount the app — that
  // looked like a full page refresh.
  if (loading && !settings) {
      return <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Spin size="large" /></div>;
  }

  // Check for onboarding status
  const isPrincipalOrAdmin = user?.role === 'super_admin' || user?.role === 'principal' || user?.role === 'developer';
  const setupCompleted = settings?.setup_completed;

  if (isPrincipalOrAdmin && !setupCompleted && location.pathname !== '/onboarding') {
      return <Navigate to="/onboarding" replace />;
  }

  if (setupCompleted && location.pathname === '/onboarding') {
      return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;